import config from '../config'
import http from '../http'

export default{
    getSellerStoreItemData:async function(payload) {
        const res = await http({
                url: config.GET_SELLERDATA_STOREITEM,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    
    createTransferOrder:async function(payload) {
        const res = await http({
                url: config.GET_transfer_add,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },

    getTransferOrder:async function(payload) {
        const res = await http({
                url: config.GET_transfer_get,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },

    sellerChooseStore:async function(payload) {
        const res = await http({
                url: config.GET_transfer_choose,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    checkOldProduct:async function(payload) {
        const res = await http({
                url: config.GET_transfer_OLDGOODS,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    newStoreCheckProduct:async function(payload) {
        const res = await http({
                url: config.GET_transfer_NEWGOODS,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    deleteStoreProduct:async function(payload) {
        const res = await http({
                url: config.GET_transfer_DELETE,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },
}